import React from "react";

function VideoAttachmentThumbnail(): JSX.Element {
  return <i className="fa fa-play text-lg" data-testid="video-attachment-thumbnail" />;
}

export default VideoAttachmentThumbnail;
